<template>
	<div>
		<v-row dense>
			<!-- categories -->
			<v-col xl="2" lg="3" sm="4" cols="12">
				<v-card>
					<v-card-title class="text-body-1 font-weight-bold pt-1 pb-1">
						<v-icon class="me-2">mdi-format-list-bulleted</v-icon>
						<span>{{$t('categories')}}</span>
					</v-card-title>
					<div :style="{ maxHeight: `${$vuetify.breakpoint.height - 130}px` }">
						<v-treeview
							:items="[{ id: null, name: $t('all') }, ...categoriesTree]"
							expand-icon="mdi-chevron-down"
							activatable
							open-all
							:active.sync="activeCategory"
							@update:active="
								$router.replace({
									name: $route.name,
									query: $event ? { category: $event } : {}
								})
							"
						/>
					</div>
				</v-card>
			</v-col>

			<!-- products -->
			<v-col xl="10" lg="9" sm="8" cols="12">
				<div v-if="activeCategory[0]" class="primary--text text-h6 text-center my-2">
					{{getCategoryById(activeCategory[0]).name}}
				</div>
				<v-row>
					<!-- all products -->
					<v-col
						v-for="category in !activeCategory[0] ? groupedProducts : []"
						:key="category.id"
						cols="12"
						class="py-0"
					>
						<div class="primary--text text-h6 text-center my-2">{{category.name}}</div>
						<v-row class="ma-0">
							<v-col
								v-for="product in category.products"
								:key="product.id"
								xl="2"
								lg="3"
								md="4"
								sm="6"
								cols="6"
							>
								<product-card :product="product" />
							</v-col>
						</v-row>
					</v-col>

					<!-- products -->
					<v-col
						v-for="product in activeCategory[0] ? filteredProducts : []"
						:key="product.id"
						xl="2"
						lg="3"
						md="4"
						sm="6"
						cols="6"
					>
						<product-card :product="product" />
					</v-col>

					<v-col
						v-if="!filteredProducts.length"
						cols="12"
						class="text-center text-body-1"
					>
						<p class="my-10">{{$t('no-products')}}</p>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'Home',
	components: {
		ProductCard,
	},

	data() {
		return {
			activeCategory: [null]
		}
	},

	watch: {
		'$route.query'(val) {
			if (!val.category) {
				this.activeCategory = [];
			}
		}
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories,
			categoriesTree: state => state.categories.categoriesTree,
			products: state => state.products.products,
		}),

		...mapGetters({
			getCategoryById: 'categories/getById'
		}),

		filteredProducts() {
			return this.products.filter(c =>
				this.activeCategory.length && this.activeCategory[0] > 0
					? c.categoriesIds.includes(+this.activeCategory[0])
					: true
			);
		},

		groupedProducts() {
			return this.categories.map(c => ({
				id: c.id,
				name: c.name,
				products: this.products.filter(e => e.categoriesIds.includes(c.id))
			}))
		}
	},

	created() {
		this.activeCategory = [+this.$route.query.category || null];
	}
}
</script>
